import styled from "styled-components";

export const Wrapper = styled.div`
  width: 1024px;
  height: 100%;
  margin: 0 auto;

  @media screen and (max-width: 1024px) {
    width: 100%;
  }
`;
